const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function req(method, path, body) {
  const secret = localStorage.getItem('air_admin_token') || '';
  const headers = { 'Content-Type': 'application/json', 'x-admin-secret': secret };
  const res = await fetch(`${BASE}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'API error');
  return data;
}

export const adminAPI = {
  // Auth — email+password
  login: (email, password) => req('POST', '/admin/login', { email, password }),

  // Dashboard stats
  getStats: () => req('GET', '/admin/stats'),

  // Books management
  getBooks: (p = {}) => req('GET', `/admin/books?${new URLSearchParams(p)}`),
  addBook: (data) => req('POST', '/admin/books', data),
  updateBook: (id, data) => req('PATCH', `/admin/books/${id}`, data),
  toggleBookStatus: (id, enabled) => req('PATCH', `/admin/books/${id}/status`, { enabled }),
  updateBookField: (id, field, value) => req('PATCH', `/admin/books/${id}/field`, { field, value }),
  bulkToggle: (ids, enabled) => req('POST', '/admin/books/bulk-status', { ids, enabled }),

  // Subjects / Categories config
  getSubjects: () => req('GET', '/admin/config/subjects'),
  addSubject: (type, name) => req('POST', '/admin/config/subjects', { type, name }),

  // Users
  getUsers: (p = {}) => req('GET', `/admin/users?${new URLSearchParams(p)}`),
  toggleUserStatus: (id, active) => req('PATCH', `/admin/users/${id}/status`, { active }),

  // Analytics
  getTopBooks: () => req('GET', '/admin/analytics/top-books'),
  getActivity: () => req('GET', '/admin/analytics/activity'),

  // Subscription management
  getSubscriptions: () => req('GET', '/admin/subscriptions'),
  updateSubscriptions: (plans) => req('PUT', '/admin/subscriptions', { plans }),
  updateUserPlan: (id, plan) => req('PATCH', `/admin/users/${id}/plan`, { plan }),
  updateUserAccessBooks: (id, access_books) => req('PATCH', `/admin/users/${id}/access-books`, { access_books }),

  // Groups
  getGroups: () => req('GET', '/admin/groups'),
  createGroup: (data) => req('POST', '/admin/groups', data),
  updateGroup: (id, data) => req('PATCH', `/admin/groups/${id}`, data),
  deleteGroup: (id) => req('DELETE', `/admin/groups/${id}`),
  getGroupUsers: (id) => req('GET', `/admin/groups/${id}/users`),
  updateGroupUsers: (id, userIds, action) => req('PATCH', `/admin/groups/${id}/users`, { userIds, action }),

  // Imported Books (from PDF-to-HTML Tool)
  getImportedBooks: (p = {}) => req('GET', `/admin/imported-books?${new URLSearchParams(p)}`),
  getImportedBook: (id, excludeContent = false) => req('GET', `/admin/imported-books/${id}${excludeContent ? '?excludeContent=true' : ''}`),
  updateImportedBook: (id, data) => req('PUT', `/admin/imported-books/${id}`, data),
  updateImportedBookStatus: (id, status) => req('PATCH', `/admin/imported-books/${id}/status`, { status }),
  deleteImportedBook: (id, deleteS3 = false) => req('DELETE', `/admin/imported-books/${id}${deleteS3 ? '?delete_s3=true' : ''}`),
};